<div class="extern-tierarzt-dialog">
    <h2 mat-dialog-title>
        <mat-icon aria-hidden="true">medical_services</mat-icon>
        <span>{{ editMode ? 'Tierarzt editieren' : 'Tierarzt hinzufügen' }}</span>
    </h2>

    <mat-dialog-content>
        <p class="dialog-hint">
            {{
                editMode
                    ? 'Wählen Sie einen anderen Tierarzt aus Ihrer Liste oder suchen Sie in der Datenbank.'
                    : 'Wählen Sie einen gespeicherten Tierarzt oder suchen Sie nach einem Namen, um einen neuen anzulegen.'
            }}
        </p>
        <kiene-extern-tierarzt-details
            #details
            (saved)="dialogRef.close($event)"
            [externTierarzt]="externTierarzt"
            [allowChange]="editMode"
            [editMode]="editMode"
        >
        </kiene-extern-tierarzt-details>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-actions">
        <button type="button" mat-button (click)="dialogRef.close()">Abbrechen</button>
        <button
            type="button"
            mat-flat-button
            color="accent"
            (click)="details.confirmSelection()"
            [disabled]="details?.isLoading || !details?.hasSelection()"
        >
            Speichern
        </button>
    </mat-dialog-actions>
</div>
